import React, { type ReactNode, useCallback, useState } from 'react'
import classNames from 'classnames'
import { Button } from '../../../components/Button/Button'
import styles from './CredentialField.module.scss'

const MASKED_VALUE = '•'.repeat(16)

interface CredentialFieldProps {
  label: string
  value: string
  copyable?: boolean
  masked?: boolean
  action?: ReactNode
  valueIcon?: ReactNode
}

export const CredentialField: React.FC<CredentialFieldProps> = ({ label, value, copyable, masked, action, valueIcon }) => {
  const [copied, setCopied] = useState<boolean>(false)

  const handleCopy = useCallback(async () => {
    await navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }, [value])

  return (
    <div className='border rounded p-3 d-flex justify-content-between align-items-center'>
      <div className='overflow-hidden'>
        <div className='small text-muted'>{label}</div>
        <span className='text-break text-secondary d-inline-flex align-items-center gap-1'>
          {valueIcon}
          {masked ? <span aria-label='Hidden value'>{MASKED_VALUE}</span> : value}
        </span>
      </div>
      {copyable ? (
        <Button variant='secondaryGhostButton' onClick={handleCopy} className='d-flex align-items-center gap-1 ms-2 flex-shrink-0'>
          <i className={copied ? 'bi bi-clipboard-check' : 'bi bi-clipboard'} />
          <span className='d-grid'>
            <span className={classNames(styles.copyLabel, { invisible: copied })} aria-hidden={copied}>
              Copy
            </span>
            <span className={classNames(styles.copyLabel, { invisible: !copied })} aria-hidden={!copied}>
              Copied
            </span>
          </span>
        </Button>
      ) : null}
      {action ?? null}
    </div>
  )
}
